module.exports = __webpack_public_path__ + "static/media/logoLQG360.72974034.png";